export const GET_CATEGORIES = "GET_CATEGORIES"
export const ERROR_CATEGORY = "ERROR_CATEGORY"
export const CLEAR_ERROR_CATEGORY = "CLEAR_ERROR_CATEGORY"
